"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasicFieldType = void 0;
// eslint-disable-next-line no-shadow
var BasicFieldType;
(function (BasicFieldType) {
    BasicFieldType["ROW_KEY"] = "rowKey";
    BasicFieldType["STRING"] = "string";
    BasicFieldType["STRINGALT"] = "stringAlt";
    BasicFieldType["VALUE"] = "value";
    BasicFieldType["NUMBER"] = "number";
    BasicFieldType["TEMPERATURE"] = "temperature";
    BasicFieldType["BOOLEAN"] = "boolean";
    BasicFieldType["DATE"] = "date";
    BasicFieldType["RELATED_MODEL"] = "relatedModel";
    BasicFieldType["RELATED_USER"] = "relatedPerson";
    BasicFieldType["RELATED_SPT"] = "relatedSPT";
    BasicFieldType["RELATED_PLACE"] = "relatedPlace";
    BasicFieldType["OP_ASSIGNEE"] = "opAssignee";
    BasicFieldType["OPDEF_FEATURES"] = "opDefFeatures";
    BasicFieldType["OPDEF_WHERE"] = "opDefWhere";
    BasicFieldType["OPDEF_WHO"] = "opDefWho";
    BasicFieldType["ISSUE_LASTCOMMENT"] = "issueLastComment";
    BasicFieldType["OP_SCORE"] = "opScore";
    BasicFieldType["OPDEF_ENABLED"] = "opEnabled";
    BasicFieldType["OPDEF_PUBLISHED"] = "opDefPublished";
    BasicFieldType["OP_ISADHOC"] = "opIsAdhoc";
    BasicFieldType["OP_ISSUE_COUNTS"] = "opIssueCounts";
    BasicFieldType["ORG_TAGS"] = "orgTags";
    BasicFieldType["WORKFLOW_ENABLED"] = "workflowEnabled";
    BasicFieldType["WORKFLOW_CONDITON"] = "workflowCondition";
    BasicFieldType["STAFF_ENABLED"] = "staffEnabled";
    BasicFieldType["ORGTEMPLATE_ENABLED"] = "orgtemplateEnabled";
    BasicFieldType["ORGTEMPLATE_ROLLOUT"] = "orgtemplateRollout";
    BasicFieldType["SUPERUSER_ORGS"] = "superuserOrgs";
})(BasicFieldType = exports.BasicFieldType || (exports.BasicFieldType = {}));
exports.default = BasicFieldType;
